import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IBaseSearchRequest } from 'src/app/core/models/base';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { IOfflineBasketItem, ISyncOfflineBasketRequest } from '../../basket/models/basket';
import { BasketService } from '../../basket/services/basket.service';
import { OfflineBasketStorageService } from '../../basket/storage/offline-basket-store.service';
import { ConnectivityStateService } from 'src/app/shared/services/connectivity-state.service';
import { Observable } from 'rxjs';
import { ICompany } from 'src/app/company/models/company';
import { CurrentBasketService } from 'src/app/basket/services/current-basket.service';


@UntilDestroy()
@Component({
    selector: 'app-offline-basket',
    templateUrl: './offline-basket.component.html',
    styleUrls: ['./offline-basket.component.scss'],
    standalone: false
})
export class OfflineBasketComponent implements OnInit {

  constructor(
    private offlineBasketStore : OfflineBasketStorageService,
    private basketService: BasketService,
    private appNotificationService: AppNotificationService,
    private connectivityStateService : ConnectivityStateService,
    private currentBasketService : CurrentBasketService
  ) { }

  @Input() offline = true;
  @Output() onReload = new EventEmitter();
  @Input() isAdminView : boolean = false;
  @Input() currentCompany: ICompany = null;

  offlineBasketItems: IOfflineBasketItem[];
  public connectionState$ : Observable<boolean> =
  this.connectivityStateService.connectionState$;

  public currentCompany$ =
    this.currentBasketService.currentCompany$;

  ngOnInit(): void {
    this.loadLocalBasket();
  }

  loadLocalBasket(){
    this.offlineBasketItems = this.offlineBasketStore.getProductsAsArray();
  }

  removeOfflineHandler(event){
    this.offlineBasketStore.removeProduct(event.dataItem.internalNumber);
    this.loadLocalBasket();
    this.appNotificationService.notification$.next({message:translate('basket.successRemoveProduct'), style:"success"})
  }

  onSyncOffline(){
    if(this.isAdminView){
      const request: ISyncOfflineBasketRequest = {
        offlineBasketItems: this.offlineBasketStore.getProductsAsArray(),
        companyId: this.currentCompany.tenantId
      }

      this.basketService.syncOfflineBasket(request)
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        if(response.notSyncedBasketItems.length > 0){
          this.appNotificationService.notification$.next({message:translate('basket.syncHasNotSyncAllItems'), style:"error"})
          this.offlineBasketStore.removeAllProducts();
          response.notSyncedBasketItems.forEach(offlineBasketItem => {
            this.offlineBasketStore.addProduct(offlineBasketItem);
          })
          this.loadLocalBasket();
          this.onReload.emit();
          
        } else {
          this.appNotificationService.notification$.next({message:translate('basket.syncSuccess'), style:"success"})
          this.offlineBasketStore.removeAllProducts();
          this.offlineBasketItems = null;
          this.onReload.emit();
        }
      })
    }
    else {
      const request: ISyncOfflineBasketRequest = {
        offlineBasketItems: this.offlineBasketStore.getProductsAsArray(),
        companyId: null
      }

      this.basketService.syncOfflineBasket(request)
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        if(response.notSyncedBasketItems.length > 0){
          this.appNotificationService.notification$.next({message:translate('basket.syncHasNotSyncAllItems'), style:"error"})
          this.offlineBasketStore.removeAllProducts();
          response.notSyncedBasketItems.forEach(offlineBasketItem => {
            this.offlineBasketStore.addProduct(offlineBasketItem);
          })
          this.loadLocalBasket();
          this.onReload.emit();
          
        } else {
          this.appNotificationService.notification$.next({message:translate('basket.syncSuccess'), style:"success"})
          this.offlineBasketStore.removeAllProducts();
          this.offlineBasketItems = null;
          this.onReload.emit();
        }
      })
    }
  }
}
